import state from './module-taxregis-state';
import mutations from './module-taxregis-mutations';
import actions from './module-taxregis-actions';
import getters from './module-taxregis-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
